export default __webpack_public_path__ + "static/media/Fortnite-logo.77899f04.svg";